import React from "react"
import Form from 'react-bootstrap/Form';
import WheelPicker from 'react-simple-wheel-picker';
import axios from "axios";
import SSTWidget from "./sstwidget"
import PdtHeader from "./pdtheader"
import { Redirect } from 'react-router';
import {Button,Modal} from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import {StateAmbContext} from '../../stateContext';
import pathSettings from '../../urlSettings.json';

class Boxloader extends React.Component {
    static contextType = StateAmbContext;
    constructor(props){
        super(props);
        this.state = {
            factorPopupOpen:false,
            factorPopupMessage:"",
            selectionmode: "boxloader_select",
            w: 6,
            h: 8,
            l: 6,
            saved:true,
            roomtemp: 35,
            application: "Cooler",
            typical_btuh: 0,
            heavy_btuh: 0,
            sst:25,
            amb_temp:95,
            btuh:5000,
            selected_option : "typical",
            temp:"Medium Temp (Cooler)",
            selected_btuh: 0,
    
            room_area: 0,
            room_vol: 0,
            settings:{},
            boxload_size: [
                { id: '6 6 8', value: <><span>06</span><span>06</span><span>08</span></> },
                { id: '6 8 8', value: <><span>06</span><span>08</span><span>08</span></> },
                { id: '6 10 8', value: <><span>06</span><span>10</span><span>08</span></> },
                { id: '8 8 8', value: <><span>08</span><span>08</span><span>08</span></> },
                { id: '8 10 8', value: <><span>08</span><span>10</span><span>08</span></> },
                { id: '8 12 8', value: <><span>08</span><span>12</span><span>08</span></> },
                { id: '8 14 8', value: <><span>08</span><span>14</span><span>08</span></> },
                { id: '8 16 8', value: <><span>08</span><span>16</span><span>08</span></> },
                { id: '8 18 8', value: <><span>08</span><span>18</span><span>08</span></> },
                { id: '8 20 8', value: <><span>08</span><span>20</span><span>08</span></> },
                { id: '8 22 8', value: <><span>08</span><span>22</span><span>08</span></> },
                { id: '8 24 8', value: <><span>08</span><span>24</span><span>08</span></> },
                { id: '8 26 8', value: <><span>08</span><span>26</span><span>08</span></> },
                { id: '8 28 8', value: <><span>08</span><span>28</span><span>08</span></> },
                { id: '8 30 8', value: <><span>08</span><span>30</span><span>08</span></> },
                { id: '8 32 8', value: <><span>08</span><span>32</span><span>08</span></> },
                { id: '10 10 8', value: <><span>10</span><span>10</span><span>08</span></> },
                { id: '10 12 8', value: <><span>10</span><span>12</span><span>08</span></> },
                { id: '10 14 8', value: <><span>10</span><span>14</span><span>08</span></> },
                { id: '10 16 8', value: <><span>10</span><span>16</span><span>08</span></> },
                { id: '10 18 8', value: <><span>10</span><span>18</span><span>08</span></> },
                { id: '10 20 8', value: <><span>10</span><span>20</span><span>08</span></> },
                { id: '10 24 8', value: <><span>10</span><span>24</span><span>08</span></> },
                { id: '10 28 8', value: <><span>10</span><span>28</span><span>08</span></> },
                { id: '12 12 8', value: <><span>12</span><span>12</span><span>08</span></> },
                { id: '12 14 8', value: <><span>12</span><span>14</span><span>08</span></> },
                { id: '12 16 8', value: <><span>12</span><span>16</span><span>08</span></> },
                { id: '12 18 8', value: <><span>12</span><span>18</span><span>08</span></> },
                { id: '12 20 8', value: <><span>12</span><span>20</span><span>08</span></> },
                { id: '12 22 8', value: <><span>12</span><span>22</span><span>08</span></> },
                { id: '14 14 8', value: <><span>14</span><span>14</span><span>08</span></> },
                { id: '14 16 8', value: <><span>14</span><span>16</span><span>08</span></> },
                { id: '14 20 8', value: <><span>14</span><span>20</span><span>08</span></> },
                { id: '14 24 8', value: <><span>14</span><span>24</span><span>08</span></> },
                { id: '16 16 8', value: <><span>16</span><span>16</span><span>08</span></> },
                { id: '16 20 8', value: <><span>16</span><span>20</span><span>08</span></> },
                { id: '16 24 8', value: <><span>16</span><span>24</span><span>08</span></> },
                { id: '18 18 8', value: <><span>18</span><span>18</span><span>08</span></> },
                { id: '18 20 8', value: <><span>18</span><span>20</span><span>08</span></> },
                { id: '18 24 8', value: <><span>18</span><span>24</span><span>08</span></> },
                { id: '20 20 8', value: <><span>20</span><span>20</span><span>08</span></> },
                { id: '20 24 8', value: <><span>20</span><span>24</span><span>08</span></> },
                { id: '20 28 8', value: <><span>20</span><span>28</span><span>08</span></> },
                { id: '20 32 8', value: <><span>20</span><span>32</span><span>08</span></> },
                { id: '20 36 8', value: <><span>20</span><span>36</span><span>08</span></> },
                { id: '20 40 8', value: <><span>20</span><span>40</span><span>08</span></> },
                { id: '40 24 8', value: <><span>40</span><span>24</span><span>08</span></> },
                { id: '40 28 8', value: <><span>40</span><span>28</span><span>08</span></> },
                { id: '40 32 8', value: <><span>40</span><span>32</span><span>08</span></> },
                { id: '40 36 8', value: <><span>40</span><span>36</span><span>08</span></> },
                { id: '40 40 8', value: <><span>40</span><span>40</span><span>08</span></> }
            ]
        }
    }
  
    updateBoxload_dimensions = (v) => {
        var r = v.id.split(" ");
        this.setState({ w: r[0], l: r[1], h: r[2] })

    }
    

    componentDidUpdate = (prev_props, prev_state) => {

        if (prev_state.w !== this.state.w || prev_state.h !== this.state.h || prev_state.l !== this.state.l ||
            prev_state.roomtemp !== this.state.roomtemp || prev_state.application !== this.state.application  ) {
            
                if(this.state.settings.marketing_service_url_2 ===undefined){
                    const res = fetch(pathSettings.settings_path,{
                        headers : { 
                          'Content-Type': 'application/json',
                          'Accept': 'application/json'
                         }
                      }).then(async(response)=>{
                        const data = await response.json();
                        this.setState({settings:data},()=>{
                            this.loadBoxloadData({
                                W: this.state.w,
                                H: this.state.h,
                                L: this.state.l,
                                roomtemp: this.state.roomtemp
                            })
                        })
                  
                      }) 
                }else{
                    this.loadBoxloadData({
                        W: this.state.w,
                        H: this.state.h,
                        L: this.state.l,
                        roomtemp: this.state.roomtemp
                    })

                }
            
           
        }
        // if(this.state.selectionmode==="direct"){
        //     this.props.onBuilder(false);
        // }else{
        //     this.props.onBuilder(true);
        // }
        // if( (prev_state.w !== this.state.w || prev_state.h !== this.state.h || prev_state.l !== this.state.l ||
        //     prev_state.roomtemp !== this.state.roomtemp || prev_state.application !== this.state.application || prev_state.typical_btuh !== this.state.typical_btuh || prev_state.heavy_btuh !==this.state.heavy_btuh)){
        //         this.triggerUpdateStateAmb();
        //     }
    }

    loadBoxloadData = (boxload) => {
        
        var application = this.state.application;
        // if (this.props.activevalue.temp === "Medium Temp (Cooler)"){
        //     application = "Cooler";  
        // } 
        this.setState({ application })

        axios.get(this.state.settings.marketing_service_url_2 +"default/getBoxload?W=" + boxload.W +
            "&H=" + boxload.H + "&L=" + boxload.L + "&roomtemp=" + boxload.roomtemp +
            "&application=" + application)
            .then((response) => {
                // handle success
                if (response.data['status'] === "success") {
                    this.setState({
                        heavy_btuh: response.data["btuh_heavy"],
                        typical_btuh: response.data["btuh_typical"],
                        room_area: response.data["room_area"],
                        room_vol: response.data["room_vol"],
                        btuh : response.data["btuh_typical"]
                    })

                }
                else
                {
                    this.setState({
                        heavy_btuh: 0,
                        typical_btuh: 0,
                        room_area: 0,
                        room_vol: 0
                    })
                }



            })
            .catch(function (error) {
                this.setState({
                    heavy_btuh: 0,
                    typical_btuh: 0,
                    room_area: 0,
                    room_vol: 0
                })

            })
            .then(function () {
                // always executed
            });

    }

    updateRoomTemp = (val,temp)=>{
        var application = (temp==="Cooler"?"Medium Temp (Cooler)":"Low Temp (Freezer)");
        
        // this.props.update("temp",application);
        if (temp==="Cooler"){
        //    this.props.update("sst",(val===35?25:20));
        var sst = (val===35?25:20);
        }else{
            var sst = 0;
            if (val===0){
                sst = -10;
            }else if(val===-10){
                sst = -20;
            }else if(val===-20){
                sst = -30
            }
            // this.props.update("sst",sst);
        }
        this.setState({roomtemp:val,application:temp,temp:application,sst:sst});
    }

    togglePopup = ()=>{
        const {t} = this.props;
        let application = this.props.tool === "Evaporator"?this.props.UC.temp:this.state.temp;
        let sst = this.props.tool === "Evaporator"?this.props.UC.sst:this.state.sst;
        let room_temp = (sst ===25?35:30);
        let factorMessage = "";
        if(application==="Medium Temp (Cooler)"){
            if(room_temp === 35){
                factorMessage = <div>
                <h4>{t('popups.ambsst.typical.rt_35.title')}</h4>
                <p>{t('popups.ambsst.typical.rt_35.desc')}</p>
                <p>{t('popups.ambsst.typical.rt_35.p1')}</p>
                <ol type={"a"}>
                    <li> {t('popups.ambsst.typical.rt_35.p1_l1')}</li>
                    <li> {t('popups.ambsst.typical.rt_35.p1_l2')}</li>
                    <li> {t('popups.ambsst.typical.rt_35.p1_l3')}</li>
                    <li> {t('popups.ambsst.typical.rt_35.p1_l4')}</li>
                    <li> {t('popups.ambsst.typical.rt_35.p1_l5')}</li>
                </ol>
                <p>{t('popups.ambsst.typical.rt_35.p2')}</p>
                <ol type={"a"}>
                    <li> {t('popups.ambsst.typical.rt_35.p2_l1')}</li>
                    <li> {t('popups.ambsst.typical.rt_35.p2_l2')}</li>
                    <li> {t('popups.ambsst.typical.rt_35.p2_l3')}</li>
                </ol>
                <p>{t('popups.ambsst.typical.rt_35.p3_1')}</p><p>{t('popups.ambsst.typical.rt_35.p3_2')}</p>
                <ol type={"a"}>
                    <li> {t('popups.ambsst.typical.rt_35.p3_l1')}</li>
                    <li> {t('popups.ambsst.typical.rt_35.p3_l2')}</li>
                </ol>
                <p>{t('popups.ambsst.typical.rt_35.p4')}</p>
                <ol type={"a"}>
                    <li> {t('popups.ambsst.typical.rt_35.p4_l1')}</li>
                    <li> {t('popups.ambsst.typical.rt_35.p4_l2')}</li>
                    <li> {t('popups.ambsst.typical.rt_35.p4_l3')}</li>
                </ol>
                <h4>{t('popups.ambsst.heavy.title_rt_35')}</h4>
                <p>{t('popups.ambsst.heavy.rt_35.desc')}</p>
                <ol type={"a"}>
                    <li> {t('popups.ambsst.heavy.rt_35.p1_l1')}</li>
                    <li> {t('popups.ambsst.heavy.rt_35.p1_l2')}</li>
                </ol>
                <p>{t('popups.ambsst.heavy.rt_35.p2')}</p>
                <p>{t('popups.ambsst.heavy.rt_35.p3')}</p>
            
            
            </div>;
            }else{
                factorMessage = <div>
                                    <h4>{t('popups.ambsst.typical.rt_other.title')}</h4>
                                    <p className="popheader1">{t('popups.ambsst.typical.rt_other.desc')}</p>
                                    <p className="popheader2">{t('popups.ambsst.typical.rt_other.p1')}</p>
                                    <ol type={"a"}>
                                        <li> {t('popups.ambsst.typical.rt_other.p1_l1')}</li>
                                        <li> {t('popups.ambsst.typical.rt_other.p1_l2')}</li>
                                        <li> {t('popups.ambsst.typical.rt_other.p1_l3')}</li>
                                        <li> {t('popups.ambsst.typical.rt_other.p1_l4')}</li>
                                        <li> {t('popups.ambsst.typical.rt_other.p1_l5')}</li>
                                    </ol>
                                    <p className="popheader1">{t('popups.ambsst.typical.rt_other.p2')}</p>
                                    <ol type={"a"}>
                                        <li> {t('popups.ambsst.typical.rt_other.p2_l1')}</li>
                                        <li> {t('popups.ambsst.typical.rt_other.p2_l2')}</li>
                                        <li> {t('popups.ambsst.typical.rt_other.p2_l3')}</li>
                                    </ol>
                                    <p className="popheader1">{t('popups.ambsst.typical.rt_other.p3_1')}</p><p>{t('popups.ambsst.typical.rt_other.p3_2')}</p>
                                    <ol type={"a"}>
                                        <li> {t('popups.ambsst.typical.rt_other.p3_l1')}</li>
                                        <li> {t('popups.ambsst.typical.rt_other.p3_l2')}</li>
                                    </ol>
                                    <p className="popheader1">{t('popups.ambsst.typical.rt_other.p4')}</p>
                                    <ol type={"a"}>
                                        <li> {t('popups.ambsst.typical.rt_other.p4_l1')}</li>
                                        <li> {t('popups.ambsst.typical.rt_other.p4_l2')}</li>
                                        <li> {t('popups.ambsst.typical.rt_other.p4_l3')}</li>
                                    </ol>
                                    <h4>{t('popups.ambsst.heavy.rt_other.title')}</h4>
                                    <p className="popheader1">{t('popups.ambsst.heavy.rt_other.desc')}</p>
                                    <ol type={"a"}>
                                        <li> {t('popups.ambsst.heavy.rt_other.p1_l1')}</li>
                                        <li> {t('popups.ambsst.heavy.rt_other.p1_l2')}</li>
                                    </ol>
                                    <p className="popheader1">{t('popups.ambsst.heavy.rt_other.p2')}</p>
                                    <p style={{textAlign:"justify"}}>{t('popups.ambsst.heavy.rt_other.p3')}</p>


                                
                                
                                </div>
            }
        }else if(application === "Low Temp (Freezer)"){
            factorMessage = <div>
           <h4>{t('popups.ambsst.typical.app_lt.title')}</h4>
            <p>{t('popups.ambsst.typical.app_lt.desc')}</p>
            <p>{t('popups.ambsst.typical.app_lt.p1')}</p>
            <ol type={"a"}>
                <li> {t('popups.ambsst.typical.app_lt.p1_l1')}</li>
                <li> {t('popups.ambsst.typical.app_lt.p1_l2')}</li>
                <li> {t('popups.ambsst.typical.app_lt.p1_l3')}</li>
                <li> {t('popups.ambsst.typical.app_lt.p1_l4')}</li>
                <li> {t('popups.ambsst.typical.app_lt.p1_l5')}</li>
            </ol>
            <p>{t('popups.ambsst.typical.app_lt.p2')}</p>
            <ol type={"a"}>
                <li> {t('popups.ambsst.typical.app_lt.p2_l1')}</li>
                <li> {t('popups.ambsst.typical.app_lt.p2_l2')}</li>
                <li> {t('popups.ambsst.typical.app_lt.p2_l3')}</li>
            </ol>
            <p>{t('popups.ambsst.typical.app_lt.p3_1')}</p><p>{t('popups.ambsst.typical.app_lt.p3_2')}</p>
            <ol type={"a"}>
                <li> {t('popups.ambsst.typical.app_lt.p3_l1')}</li>
                <li> {t('popups.ambsst.typical.app_lt.p3_l2')}</li>
            </ol>
            <p>{t('popups.ambsst.typical.app_lt.p4')}</p>
            <ol type={"a"}>
                <li> {t('popups.ambsst.typical.app_lt.p4_l1')}</li>
                <li> {t('popups.ambsst.typical.app_lt.p4_l2')}</li>
                <li> {t('popups.ambsst.typical.app_lt.p4_l3')}</li>
            </ol>
            <h4>{t('popups.ambsst.heavy.app_lt.title')}</h4>
            <p>{t('popups.ambsst.heavy.app_lt.desc')}</p>
            <ol type={"a"}>
                <li> {t('popups.ambsst.heavy.app_lt.p1_l1')}</li>
                <li> {t('popups.ambsst.heavy.app_lt.p1_l2')}</li>
            </ol>
            <p>{t('popups.ambsst.heavy.app_lt.p2')}</p>
            <p>{t('popups.ambsst.heavy.app_lt.p3')}</p>


        
        
        </div> ;
        }
        this.setState({"factorPopupOpen":!this.state.factorPopupOpen,"factorPopupMessage":factorMessage})
    }
    // triggerUpdateStateAmb = ()=>{
    //     const { updateStateAmb } = this.context;
    //     var dataAmbsState = {
    //         w: this.state.w,
    //         h: this.state.h,
    //         l: this.state.l,
    //         saved: this.state.saved,
    //         roomtemp: this.state.roomtemp,
    //         application: this.state.application,
    //         typical_btuh: this.state.typical_btuh,
    //         heavy_btuh: this.state.heavy_btuh,
    //         boxloaded: this.state.boxloaded,
    //         selected_option : this.state.selected_option,
    //         selected_btuh: this.state.selected_btuh,
    //         room_area: this.state.room_area,
    //         room_vol: this.state.room_vol
    //     };
        
    //     updateStateAmb(dataAmbsState);

    // };
    render() {
        const {t} = this.props;
        const { settings }  = this.context;
        var dataAmbsState = {
            w: this.state.w,
            h: this.state.h,
            l: this.state.l,
            saved: this.state.saved,
            roomtemp: this.state.roomtemp,
            application: this.state.application,
            typical_btuh: this.state.typical_btuh,
            heavy_btuh: this.state.heavy_btuh,
            boxloaded: this.state.boxloaded,
            selected_option : this.state.selected_option,
            room_area: this.state.room_area,
            room_vol: this.state.room_vol
        };
        

        return (
            <>
            <div>
            
            <Modal show={this.state.factorPopupOpen} onHide={this.togglePopup}>
                <Modal.Header closeButton>
                <Modal.Title>{t('ambsst_Ques.modal_title')}</Modal.Title>
                </Modal.Header>
                <Modal.Body><p style={{fontSize:"smaller"}}>{t('ambsst_Ques.modal_body')}{this.state.factorPopupMessage}</p></Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={this.togglePopup}>
                {t('common.close')}
                </Button>
                </Modal.Footer>
            </Modal>
        
            </div>
            {/* <Header /> */}
            {this.props.tool==="quickloader"?<PdtHeader tool={this.props.tool} unit={"Quickloader"} />:<></>}
            <div >
                {/* {(this.state.selectionmode === "direct") ? <div className="custom_container m-auto "> */}
               <div className="custom_container m-auto " >

                    <div className="card-deck card-main card_gr mbtm20">

                        <div className="card justify-content-center">
                        <div className="bg-gray br-5">
                            <div className="card-body p-15">
                                <div className="dropdown show boldst ">
                                    <div className="row plr15 calculate_main">
                                            <div  >
                                            <Form.Group controlId="amptemp">
                                                <Form.Label>{t('ambsst_Ques.amb_temp_ques')}</Form.Label>
                                                <Form.Control
                                                    disabled={this.state.saved}
                                                    value={this.state.amb_temp}
                                                    onChange={(e) => { this.setState({"amb_temp":e.target.value}) }}
                                                    style={{ width: "100%",background:(this.state.saved?"#b1b3b6":"#fff")}} as="select">
                                                    <option value="90">{t('common.temp_deg.90F')}</option>
                                                    <option value="95">{t('common.temp_deg.95F')}</option>
                                                    <option value="100">{t('common.temp_deg.100F')}</option>
                                                    <option value="110">{t('common.temp_deg.110F')}</option>
                                                    <option value="115">{t('common.temp_deg.115F')}</option>
                                                    <option value="120">{t('common.temp_deg.120F')}</option>
                                                </Form.Control>
                                            </Form.Group>
                                            </div>
                                            <div >
                                            <Form.Group controlId="sst">
                                                <Form.Label>{t('ambsst_Ques.sst_ques')}</Form.Label>
                                                <Form.Control
                                                    disabled={this.state.saved}
                                                    value={this.state.sst}
                                                    onChange={(e) => { this.setState({"sst":e.target.value}) }}
                                                    style={{ width: "100%",background:(this.state.saved?"#b1b3b6":"#fff")}} as="select">
                                                     {this.state.temp==="Medium Temp (Cooler)"?<> <option value="35">{t('ssts.35F')}</option>
                                                        <option value="30">{t('ssts.30F')}</option>
                                                        <option value="25">{t('ssts.25F')}</option>
                                                        <option value="20">{t('ssts.20F')}</option></>:<><option value="-10">{t('ssts.-10F')}</option>
                                                        <option value="-20">{t('ssts.-20F')}</option>
                                                        <option value="-30">{t('ssts.-30F')}</option></>}
                                                </Form.Control>
                                            </Form.Group>
                                            </div>
                                            {/* <div className={this.state.saved?"":"bdr-right"} > */}
                                            <div className="bdr-right" >
                                            <Form.Group controlId="btuh">
                                                <Form.Label>{t('ambsst_Ques.btu_header')}</Form.Label>
                                                <Form.Control type="number" value={this.state.btuh}
                                                    disabled={this.state.saved}
                                                    onChange={(e) => { this.setState({"btuh": e.target.value}) }}
                                                    style={{background:(this.state.saved?"#b1b3b6":"#fff")}}
                                                    placeholder={t('ambsst_Ques.enter_btu')} />
                                                <Form.Text className="text-muted">
                                                    {/* Type a capacity between 5,000 and 200,000 */}
                                                </Form.Text>
                                                </Form.Group>
                                            </div>
                                            <div className="capacity" hidden={this.state.saved}>
                                               <b>{t('ambsst_Ques.dnt_knw_cap')} <br></br>{t('ambsst_Ques.ur_cap')}</b> 
                                            </div>
                                            {/* <div className="col-sm-3" hidden={this.state.saved} > */}
                                            <div hidden={this.state.saved} className="btn-calculate_main">
                                                <div hidden={this.props.tool==="quickloader"?true:false} type="button" className="btn-calculate float-right" onClick={() => { this.setState({ selectionmode: "boxloader_select" })}}>{t('ambsst_Ques.cal_bx_loadd')}</div>
                                            </div>
                                    </div>
                                </div>
                                </div> 
                                </div>

                        </div>
                      
                    
                    </div>
                </div>
                {/* </div> : <></>} */}
                {(this.state.selectionmode === "boxloader_select") ?
                    <div className="custom_container">
                    <div className="row mstyle ">
                    <div className="col-sm-6 ">
                        <div className="card-deck card-main card_gr ">
                        
                            <div className="col-sm-12 paddst">
                                <div>
                                    <div className="card-body text-center sstmain">

                                        <Form.Group controlId="sst">
                                            <Form.Label>{t('boxloader.select_rm_dim')}</Form.Label>
                                            <div className="date_head"><p>{t('boxloader.W')}</p>
                                            <p>{t('boxloader.L')}</p>
                                            <p>{t('boxloader.H')}</p></div>
                                            <div className="wheelpicker">
                                                <WheelPicker
                                                    data={this.state.boxload_size}
                                                    onChange={this.updateBoxload_dimensions}
                                                    height={75}
                                                    width={150}
                                                    titleText="W L H"
                                                    itemHeight={30}
                                                    selectedID={this.state.w + " " + this.state.l + " " + this.state.h}
                                                    color="#ccc"
                                                    activeColor="#333"
                                                    backgroundColor="#fff"
                                                    shadowColor="#fff"
                                                />
                                            </div>
                                        </Form.Group>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12 paddst">
                                <div>
                                    <div className="card-body text-center sstmain mtop30 slider-container">

                                        <Form.Group controlId="sst">
                                            <Form.Label> {t('boxloader.select_rt')}</Form.Label>
                                            {/* <Form.Control
                                                value={this.state.roomtemp}
                                                onChange={(e) => { this.setState({ roomtemp: e.target.value }) }}
                                                style={{ maxWidth: "100px", marginLeft: "calc( 50% - 50px )" }} as="select">
                                                {this.props.activevalue.temp==="Medium Temp (Cooler)"?<>
                                                    <option value="30">30</option>
                                                    <option value="35">35</option>
                                                </>:<>
                                                 <option value="0">0</option>
                                                <option value="-10">-10</option>
                                                <option value="-20">-20</option>
                                                </>}                                                
                                            </Form.Control> */}

                                            <SSTWidget roomtemp={this.state.roomtemp} application={this.state.temp} update={this.props.update} updateRoomtemp = {this.updateRoomTemp} />
                                            {/*<Form.Control type="range" min="-20" max="30" step="10"/>*/}
                                        </Form.Group>
                                    </div>
                                </div>
                                <div>

                                </div>
                            </div>
                            </div>

                        </div>

                        <div className="col-sm-6 grey_main ">
                            <b className="font20 color-blue">{t('boxloader.Results')}</b>

                            <table className="table table_st boxload_table">
                                <tbody>
                                    <tr className="bdr">
                                        <td><b>{t('boxloader.rm_area')}</b></td>
                                        <td>{this.state.room_area.toLocaleString()} ft²</td>
                                    </tr>
                                    <tr className="bdr">
                                        <td><b>{t('boxloader.rm_vol')}</b></td>
                                        <td>{this.state.room_vol.toLocaleString()} ft³</td>
                                    </tr>
                                    <tr className="bdr">
                                        <td><b>{t('boxloader.rm_temp')}</b></td>
                                        <td>{this.state.roomtemp}ºF ({this.state.application})</td>
                                    </tr>
                                    <tr>
                                        <td className="radio_td">
                                        <Form.Check
                                                type="radio"
                                                id="typicalload"
                                                label="Typical Load"
                                                name="usage"
                                                defaultChecked={this.state.selected_option==="typical" ? true : false} 
                                                onClick = {()=>{ this.setState({ selected_option :"typical",btuh:this.state.typical_btuh}) }}
                                            />
                                        </td>
                                        <td>{this.state.typical_btuh.toLocaleString()} {t('boxloader.btuh')}</td>
                                    </tr>
                                    <tr >
                                        <td className="radio_td">
                                            <Form.Check
                                                type="radio"
                                                id="heavyload"
                                                label="Heavy Load"
                                                name="usage"
                                                defaultChecked={this.state.selected_option==="heavy" ? true : false} 
                                                onClick = {()=>{ this.setState({ selected_option : "heavy" ,btuh:this.state.heavy_btuh}) }}
                                            />
                                        </td>
                                        <td>{this.state.heavy_btuh.toLocaleString()} {t('boxloader.btuh')}</td>
                                    </tr>
                                    <tr>
                                    <td colSpan = "2" style={{fontSize:"smaller"}}>
                                            <p className="color-blue m-0">{t('boxloader.note_1')}  <span onClick={this.togglePopup} style={{cursor:"pointer"}}>{t('boxloader.click_here')}</span> {t('boxloader.note_2')}</p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                                <div className="">
                            <div type="button" className="next-pre-btn float-right" onClick={() => {
                                if (this.state.selected_option === "typical") {
                                    this.setState({"btuh": this.state.typical_btuh});
                                }
                                if (this.state.selected_option === "heavy") {
                                    this.setState({"btuh": this.state.heavy_btuh});
                                }
                                if (this.state.application === "heavy") {
                                    this.setState({"btuh": this.state.heavy_btuh});
                                }
                                this.setState({ selectionmode: "direct",saved:true }
                                );
                                // Need to find the correct way to navigate back
                                var currentUrl = (window.location.href).split("?")[0]
                                // window.location.href = currentUrl + "?boxObj="+window.btoa(JSON.stringify({boxloadState:{'sst':this.state.sst,'temp':this.state.temp,'btuh':this.state.btuh},'dataAmbsState':dataAmbsState}))
                                window.location.href = settings.app_location+"?boxObj="+JSON.stringify({boxloadState:{'sst':this.state.sst,'temp':this.state.temp,'btuh':this.state.btuh},'dataAmbsState':dataAmbsState})

                            }}>{t('boxloader.select_eqp')}</div>
                            <div hidden={this.props.tool==="quickloader"?true:false} type="button" className="next-pre-btn" onClick={() => { this.setState({ selectionmode: "direct",saved:false })
                            }}>{t('boxloader.cancel')}</div>

                        <div hidden={this.props.tool==="quickloader"?false:true} type="button" className="next-pre-btn" onClick={() => {
                        // window.location.href = "/";
                        // var currentUrl = (window.location.href).split("?")[0]
                        // window.location.href = currentUrl;
                        window.location.href = settings.app_location;

                    }}><i className="fa  fa-angle-left"></i> {t('boxloader.back')}</div>
                        </div>

                        </div>
                        </div>
                    </div>  : <></>}
            </div></>);
    }
}
export default withTranslation() (Boxloader);